import { getEnv } from './getEnv';

const MAX_RETRIES = 3;
const RETRY_DELAYS = [1000, 2000, 4000];

const retryWorkerStart = async (worker, options) => {
  for (let attempt = 0; attempt <= MAX_RETRIES; attempt++) {
    try {
      return await worker.start(options);
    } catch (error) {
      if (attempt === MAX_RETRIES) throw error;
      const delay = RETRY_DELAYS[attempt];
      console.warn(
        `[MSW] Worker registration failed (attempt ${attempt + 1}/${
          MAX_RETRIES + 1
        }). Retrying in ${delay}ms...`,
        error.message,
      );
      await new Promise(resolve => setTimeout(resolve, delay));
    }
  }
};

export const prepare = () => {
  /* istanbul ignore else */
  if (getEnv('REACT_APP_MOCK_API') === 'true') {
    const { worker } = require('../api/mock-api');
    return retryWorkerStart(worker, {
      onUnhandledRequest: req => {
        /* istanbul ignore next */
        if (req.url.href.indexOf(getEnv('REACT_APP_ADMIN_API_URL')) > -1) {
          throw new Error('Must mock incentivio api requests');
        }
      },
    });
  }

  /* istanbul ignore next */
  return Promise.resolve();
};
